import Vue from 'vue';
import api from '@/plugins/api';

const initialState = Vue.observable({
    validate: {roles: []},
    isInitialized: false,
});

const state = Vue.observable({...initialState});


export const authStore = {
    state,

    /**
     * Verifica se o usuário logado tem a permissão de Administrador.
     * Lê diretamente do estado do store.
     * Pode ser usado em qualquer componente Vue.
     * @returns {boolean} Retorna true se o usuário for administrador, caso contrário false
     */
    isAdmin() {
        return this.state.validate.roles.includes('ROLE_ADMIN');
    },

    /**
     * Ação para buscar os dados do usuário (só executa uma vez)
     */
    async initialize() {

        if (this.state.isInitialized) {
            return;
        }
        const token = localStorage.getItem('token');
        if (!token) {
            this.state.isInitialized = true;
            return;
        }

        try {
            const response = await api.get("/api/validate");
            this.state.validate = response.data;
            this.state.isInitialized = true;
        } catch (error) {
            console.error("Falha ao inicializar o store de autenticação:", error);
            this.reset();
        }
    },

    /**
     * Limpa os dados de autenticação do usuário.
     * DEVE ser chamado na função de LOGOFF.
     */
    reset() {
        Object.assign(this.state, initialState);
    }

};